document.addEventListener('DOMContentLoaded', ()=>{
    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
    const header = document.querySelector('.section-header');

    let swiperInstance = null;
    function initOrDestroySwiper() {
        const mediaEl = document.querySelector('.media__exceution_swiper.swiper');
        if (!mediaEl) return;
        const isMobile = window.innerWidth < 750;
        if (isMobile && !swiperInstance) {
            const mediaConfig = {spaceBetween:0,slidesPerView:1.05,pagination:{el:'.swiper-pagination',type:'progressbar'} };
            swiperInstance = new Swiper(mediaEl, mediaConfig);
        }
        if (!isMobile && swiperInstance) { swiperInstance.destroy(true, true); swiperInstance = null; }
    }
    initOrDestroySwiper(); 
    window.addEventListener('resize', function(event) { initOrDestroySwiper() }, true);

    const testimonialEl = document.querySelector('.Testimonial__reviews_interior.swiper');
    if (testimonialEl) {
        const testimonialConfig = { spaceBetween: 12, slidesPerView: 'auto', grabCursor: true };
        if (!isIOS) {
            testimonialConfig.mousewheel = { forceToAxis: true, thresholdDelta: 35 };
            testimonialConfig.freeMode = true;
        }
        new Swiper(testimonialEl, testimonialConfig);
    } 

    const swiperElements = document.querySelectorAll('.iconText_highPricePoint_swipe.swiper');
    if (swiperElements.length > 0) {
        swiperElements.forEach((elm, index) => {
            const config = { spaceBetween: 12, slidesPerView: 'auto', allowTouchMove: true, grabCursor: true, };
            if (!isIOS) { config.mousewheel = { forceToAxis: true, thresholdDelta: 35 }; config.freeMode = true; }
            new Swiper(elm, config);
        });
    }    

    const getGuid = ()=> {
        let d = new Date().getTime();
        let d2 =  (performance && performance.now && (performance.now() * 1000)) || 0;
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
            let r = Math.random() * 16;
            if (d > 0) {
                r = (d + r) % 16 | 0;
                d = Math.floor(d / 16);
            } else {
                r = (d2 + r) % 16 | 0;
                d2 = Math.floor(d2 / 16);
            }
            return (c == 'x' ? r: (r & 0x7 | 0x8)).toString(16);
        }); 
    }    

    if( document.querySelectorAll('[js-subscribe-processing-cart]').length > 0 ) {
        const subscribeIdMap = {};
        let subscribeBoxIndexCounter = 0;        
        document.querySelectorAll('[js-subscribe-processing-cart]').forEach((elm) => {
            elm.addEventListener('click', (event) => {
                event.preventDefault();
                const Etarget = event.currentTarget;
                const productFormObject = Etarget.closest('.pdp__single_tw_o__content').querySelector(`.single_tw_o__content__form`).querySelector(`form`);
                const submitButton = Etarget.closest('.single_tw_o__content__bt__button').querySelector('button');
                submitButton.classList.add('loading');
                submitButton.disabled = true;
                let cartElement = document.querySelector("cart-drawer");
                if (cartElement) cartElement.enableLoading();
                let itemsToAdd = [];
                const isCustomProcess = Etarget.closest('[data-cart-process="true"]');
                if (isCustomProcess) {
                    const currentVariantId = productFormObject.querySelector('[name="id"]').value;
                    const bundleJson = JSON.parse(Etarget.closest(`.pdp__single_tw_o__content_nt`).querySelector(`.single_tw_o__content__form`).querySelector(`cus-variants-single-two`).querySelector('.bundle-data-json').textContent);
                    const data = bundleJson[currentVariantId];
                    if (data && data.ids) {
                        let uniqID = new Date().getTime().toString(),
                        bundleID = data.dynbox,
                        customImage = data.custom_image,
                        customProductTitle = data.product_title,
                        customTitle = data.custom_title,
                        customServing = data.custom_servings,
                        customPrice = data.custom_price,
                        customComparePrice = data.custom_compare_price,
                        customSubPrice = data.custom_sub_price,
                        customSubComparePrice = data.custom_sub_compare_price,                        
                        customQuantity = data.custom_quantity,
                        customQuantityGroup = data.qtys,
                        customSellingPlan = data.custom_selling_plan,
                        dynamicBoxIndex = 0;
                        if (bundleID && bundleID.toString().trim() !== '') {
                            const trimmedBundleID = bundleID.toString().trim();
                            if (subscribeIdMap[trimmedBundleID] === undefined) {
                                subscribeIdMap[trimmedBundleID] = subscribeBoxIndexCounter;
                                subscribeBoxIndexCounter++;
                            }
                            dynamicBoxIndex = subscribeIdMap[trimmedBundleID];
                        }
                        const mainProperties = {
                            _dynamicBoxId: bundleID,
                            _dynamicBoxIndex: dynamicBoxIndex,
                            _custom_product_title:customProductTitle,
                            _custom_image:customImage,
                            _custom_title:customTitle,
                            _custom_serving:customServing,
                            _custom_price:customPrice,
                            _custom_compare_price:customComparePrice,
                            _custom_sub_price:customSubPrice,
                            _custom_sub_compare_price:customSubComparePrice,                            
                            _custom_quantity:customQuantity,
                            _custom_quantity_group:customQuantityGroup,
                            _customSellingPlanName:customSellingPlan
                        }; 
                        const idArray = typeof data.ids === 'string' ? data.ids.split(',') : data.ids;
                        const planArray = typeof data.plans === 'string' ? data.plans.split(',') : (data.plans || []);
                        const qtyArray = typeof data.qtys === 'string' ? data.qtys.split(',') : (data.qtys || []);
                        itemsToAdd = idArray.map((id, index) => {
                            const itemBaseQty = parseInt(qtyArray[index]) || 1;
                            const itemProperties = { 
                            ...mainProperties,
                            _base_qty: itemBaseQty.toString(),
                            _role: index === 0 ? 'main' : 'hidden',
                            _uniqBundleId: uniqID
                            };
                            const item = {
                                id: id.toString().trim(),
                                quantity: itemBaseQty,
                                properties: itemProperties
                            };
                            if (planArray[index] && planArray[index] !== "") {
                                item.selling_plan = parseInt(planArray[index]);
                            }
                            return item;
                        });
                    }
                }else{
                    let sellingId = productFormObject.querySelector('[name="selling_plan_id"]')?.value;
                    let targetId = productFormObject.querySelector('[name="id"]').value;
                    itemsToAdd.push({
                        id: targetId,
                        quantity: 1,
                        selling_plan: sellingId || null
                    });
                }
                const productShouldBe = {
                    items: itemsToAdd,
                    sections: cartElement ? cartElement.getSectionsToRender().map((section) => section.section) : [],
                    sections_url: window.location.pathname
                };
                fetch('/cart/add.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'X-Requested-With': 'XMLHttpRequest'
                    },
                    body: JSON.stringify(productShouldBe),
                    credentials: 'same-origin'
                })
                .then(async (response) => {
                    const data = await response.json();
                    if (!response.ok) {
                        console.error("Shopify Cart Error Response:", data);
                        throw new Error(data.description || data.message || "Failed to add items to cart (409 Conflict)");
                    }
                    return data;
                })
                .then((parsedState) => {
                    if (cartElement) cartElement.renderContent(parsedState.sections);
                })
                .catch((e) => console.error(e))
                .finally(() => {
                    if (cartElement) {
                        cartElement.disableLoading();
                        cartElement.open();
                        document.querySelector('.cart_drawers__cross')?.setAttribute('role', 'button');
                        document.querySelector('.cart_drawers__cross')?.setAttribute('tabindex', '0');                        
                    }
                    submitButton.classList.remove('loading');
                    submitButton.disabled = false;
                });
            });
        });
    }

    if( document.querySelectorAll('[js-onetime-processing-cart]').length > 0 ) {
        const onetimeIdMap = {};
        let onetimeBoxIndexCounter = 0;        
        document.querySelectorAll('[js-onetime-processing-cart]').forEach((elm) => {
            elm.addEventListener('click', (event) => {
                event.preventDefault();
                const Etarget = event.currentTarget;
                const productFormObject = Etarget.closest('.pdp__single_tw_o__content').querySelector(`.single_tw_o__content__form`).querySelector(`form`);
                const submitButton = Etarget.closest('.single_tw_o__content__bt__button_ot').querySelector('button');
                submitButton.classList.add('loading');
                submitButton.disabled = true;
                let cartElement = document.querySelector("cart-drawer");
                if (cartElement) cartElement.enableLoading();
                let itemsToAdd = [];
                const isCustomProcessOneTime = Etarget.closest('[data-cart-process="true"]');
                if (isCustomProcessOneTime) {
                    const currentVariantIdOT = productFormObject.querySelector('[name="id"]').value;
                    const sectionContainerOT = Etarget.closest('[data-cart-process]');
                    const bundleJsonOT = JSON.parse(sectionContainerOT.querySelector('.bundle-data-json').textContent);
                    const dataOT = bundleJsonOT[currentVariantIdOT];
                    if (dataOT && dataOT.ids) {
                    let uniqID = new Date().getTime().toString(),
                        bundleID = dataOT.dynbox,
                        customImage = dataOT.custom_image,
                        customProductTitle = dataOT.product_title,
                        customTitle = dataOT.custom_title,
                        customServing = dataOT.custom_servings,
                        customPrice = dataOT.custom_price,
                        customComparePrice = dataOT.custom_compare_price,
                        customSubPrice = dataOT.custom_sub_price,
                        customSubComparePrice = dataOT.custom_sub_compare_price,                        
                        customQuantity = dataOT.custom_quantity,
                        customQuantityGroup = dataOT.qtys,
                        customSellingPlan = dataOT.custom_selling_plan,
                        dynamicBoxIndex = 0;
                        if (bundleID && bundleID.toString().trim() !== '') {
                            const trimmedBundleID = bundleID.toString().trim();
                            if (onetimeIdMap[trimmedBundleID] === undefined) {
                                onetimeIdMap[trimmedBundleID] = onetimeBoxIndexCounter;
                                onetimeBoxIndexCounter++;
                            }
                            dynamicBoxIndex = onetimeIdMap[trimmedBundleID];
                        }
                        const mainProperties = {
                            _dynamicBoxId: bundleID,
                            _dynamicBoxIndex: dynamicBoxIndex,
                            _custom_product_title:customProductTitle,
                            _custom_image:customImage,
                            _custom_title:customTitle,
                            _custom_serving:customServing,
                            _custom_price:customPrice,
                            _custom_compare_price:customComparePrice,
                            _custom_sub_price:customSubPrice,
                            _custom_sub_compare_price:customSubComparePrice,                            
                            _custom_quantity:customQuantity,
                            _custom_quantity_group:customQuantityGroup,
                            _customSellingPlanName:customSellingPlan
                        };
                        const idArrayOT = typeof dataOT.ids === 'string' ? dataOT.ids.split(',') : dataOT.ids;
                        const planArrayOT = typeof dataOT.plans === 'string' ? dataOT.plans.split(',') : (dataOT.plans || []);
                        const qtyArrayOT = typeof dataOT.qtys === 'string' ? dataOT.qtys.split(',') : (dataOT.qtys || []);
                        itemsToAdd = idArrayOT.map((id, index) => {
                            const itemBaseQty = parseInt(qtyArrayOT[index]) || 1;
                            const itemProperties = { 
                                ...mainProperties,
                                _base_qty: itemBaseQty.toString(),
                                _role: index === 0 ? 'main' : 'hidden',
                                _uniqBundleId: uniqID,
                                _selling_plan_id: parseInt(planArrayOT[index])
                            };                            
                            const item = {
                                id: id.toString().trim(),
                                quantity: itemBaseQty,
                                properties:itemProperties
                            };
                            return item;
                        });
                    }
                }else{
                    let targetId = productFormObject.querySelector('[name="id"]').value;
                    itemsToAdd.push({
                        id: targetId,
                        quantity: 1
                    });
                }
                const productShouldBe = {
                    items: itemsToAdd,
                    sections: cartElement ? cartElement.getSectionsToRender().map((section) => section.section) : [],
                    sections_url: window.location.pathname
                };
                fetch('/cart/add.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'X-Requested-With': 'XMLHttpRequest'
                    },
                    body: JSON.stringify(productShouldBe),
                    credentials: 'same-origin'
                })
                .then(async (response) => {
                    const data = await response.json();
                    if (!response.ok) {
                        console.error("Shopify Cart Error Response:", data);
                        throw new Error(data.description || data.message || "Failed to add items to cart (409 Conflict)");
                    }
                    return data;
                })
                .then((parsedState) => {
                    if (cartElement) cartElement.renderContent(parsedState.sections);
                })
                .catch((e) => console.error(e))
                .finally(() => {
                    if (cartElement) {
                        cartElement.disableLoading();
                        cartElement.open();
                        document.querySelector('.cart_drawers__cross')?.setAttribute('role', 'button');
                        document.querySelector('.cart_drawers__cross')?.setAttribute('tabindex', '0');                        
                    }
                    submitButton.classList.remove('loading');
                    submitButton.disabled = false;
                });
            });
        });
    }
    
    if( document.querySelectorAll('.video__playIcon').length > 0 ){
        document.querySelectorAll('.video__playIcon .action--pause').forEach((elm)=>{
            elm.addEventListener('click', (target)=>{
                target.preventDefault();
                target.currentTarget.classList.add('hidden');
                target.target.closest('.Testimonial__video_tagged').querySelector('.action--play').classList.remove('hidden');
                target.target.closest('.Testimonial__video_tagged').querySelector('video').pause();
            })
        });
        document.querySelectorAll('.video__playIcon .action--play').forEach((elm)=>{
            elm.addEventListener('click', (target)=>{
                target.preventDefault();
                target.currentTarget.classList.add('hidden');
                target.target.closest('.Testimonial__video_tagged').querySelector('.action--pause').classList.remove('hidden');
                target.target.closest('.Testimonial__video_tagged').querySelector('video').play();
            })
        });  
    }

    if( document.querySelectorAll('[js-doctor-dietitian-lightbox]').length > 0 ){
        document.querySelectorAll('[js-doctor-dietitian-lightbox]').forEach((elm)=>{
            elm.addEventListener('click',(target)=>{
                target.preventDefault();
                let lighhtbox_doctor = document.querySelector('.doctor_dietitian_lightbox_html').innerHTML;
                document.querySelector('.doctor_dietitian_lightbox').innerHTML = lighhtbox_doctor;
                document.querySelector('.doctor_dietitian_lightbox').classList.add('active');
                document.querySelector('.page-overlay').classList.add('is-visible');
                document.body.classList.add('overflow-hidden');
            })
        })   
    }
    
    class doctorDietitian extends HTMLElement{
        constructor(){
        super();
            this.querySelectorAll('[js-doctor-dietitian-lightbox-close]').forEach((elm)=>{
                elm.addEventListener('click',(target)=>{
                    target.preventDefault();
                    document.querySelector('.doctor_dietitian_lightbox').innerHTML = ``;
                    document.querySelector('.doctor_dietitian_lightbox').classList.remove('active');
                    document.querySelector('.page-overlay').classList.remove('is-visible');
                    document.body.classList.remove('overflow-hidden');
                })
            })       
        }
    }
    window.customElements.define('cus-dietitian-widget',doctorDietitian);

    function isInViewport(elem) {
        const rect = elem.getBoundingClientRect();
        return (
            rect.bottom >= 0 &&
            rect.right >= 0 &&
            rect.top <= (window.innerHeight || document.documentElement.clientHeight) &&
            rect.left <= (window.innerWidth || document.documentElement.clientWidth)
        );
    }
    
    const stickyBar = document.querySelector('.rainforest__sticky_button_actions');
    const headerHeight = header ? header.clientHeight : 0;
    const addToCartElements = document.querySelectorAll('[js-subscribe-processing-cart]');
    const footerSections = document.querySelectorAll('.footer__main_wrapper');
    const recentlyViewedSections = document.querySelectorAll('[section="product-recently-viewed"]');
    
    function shouldHideSticky() {
        for (const el of [...addToCartElements, ...footerSections, ...recentlyViewedSections]) {
        if (el && isInViewport(el)) return true;
        }
        return false;
    }
    
    function handleStickyScroll() {
        const scrollY = window.scrollY;
        const triggerElement = document.querySelector('[js-subscribe-processing-cart]');
        if (!triggerElement || !stickyBar) return;
        const triggerOffset = triggerElement.offsetTop;
        if (scrollY > triggerOffset) {
            if (shouldHideSticky()) {
                stickyBar.classList.remove('stickyAddToCart');
                stickyBar.style.top = `-100%`;
            } else {
                stickyBar.classList.add('stickyAddToCart');
                stickyBar.style.top = `${headerHeight}px`;
            }
        } else {
            stickyBar.classList.remove('stickyAddToCart');
            stickyBar.style.top = `-100%`;
        }
    }
    window.addEventListener('scroll', handleStickyScroll, { passive: true });

    const stickyButton = document.querySelector('.rainforest__sticky_button_actions .rainforest__buttonScroll');
    const scrollTarget = document.querySelector('.single_tw_o__content__form');
    if (stickyButton && header && scrollTarget) {
        stickyButton.addEventListener('click', (e) => {
            e.preventDefault();
            const offset = scrollTarget.offsetTop - header.clientHeight;
            window.scrollTo({
                top: offset,
                behavior: 'smooth'
            });
        });
    }
        
    const stickyFormContainer = document?.querySelector('.rainforest__sticky_button_actions');
    const productForm = document?.querySelector('.single_tw_o__content__form')?.querySelector('cus-variants-single-two');
    const cartDrawerSticky = document?.querySelector('cart-drawer');

    if (stickyFormContainer && productForm) {
        const submitBtns = stickyFormContainer.querySelectorAll('.product-form__submit');
        const stickyIdMap = {};
        let stickyBoxIndexCounter = 0;          

        submitBtns.forEach(submitBtn => {
            submitBtn?.addEventListener('click', (e) => {
                e.preventDefault();
                const variantId = productForm.querySelector('[name="id"]')?.value;
                const sellingPlanId = productForm.querySelector('[name="selling_plan_id"]')?.value;
                let itemsToAdd = [];
                const isCustomProcess = e.target.closest(`.shopify-section`)?.querySelector('[data-cart-process="true"]');
                
                if (isCustomProcess) {
                    const bundleJsonNode = e.target.closest(`.shopify-section`)?.querySelector(`.pdp__single_tw_o__main`)?.querySelector(`.pdp__single_tw_o__content_nt`)?.querySelector(`.single_tw_o__content__form`)?.querySelector(`cus-variants-single-two`)?.querySelector('.bundle-data-json');
                    
                    if (bundleJsonNode) {
                        const bundleJson = JSON.parse(bundleJsonNode.textContent);
                        const data = bundleJson[variantId];
                        if (data && data.ids) {
                            let uniqID = new Date().getTime().toString(),
                                bundleID = data.dynbox,
                                customImage = data.custom_image,
                                customProductTitle = data.product_title,
                                customTitle = data.custom_title,
                                customServing = data.custom_servings,
                                customPrice = data.custom_price,
                                customComparePrice = data.custom_compare_price,
                                customSubPrice = data.custom_sub_price,
                                customSubComparePrice = data.custom_sub_compare_price,           
                                customQuantity = data.custom_quantity,
                                customQuantityGroup = data.qtys,
                                customSellingPlan = data.custom_selling_plan,
                                dynamicBoxIndex = 0;

                            if (bundleID && bundleID.toString().trim() !== '') {
                                const trimmedBundleID = bundleID.toString().trim();
                                if (stickyIdMap[trimmedBundleID] === undefined) {
                                    stickyIdMap[trimmedBundleID] = stickyBoxIndexCounter;
                                    stickyBoxIndexCounter++;
                                }
                                dynamicBoxIndex = stickyIdMap[trimmedBundleID];
                            }
                            
                            const mainProperties = {
                                _dynamicBoxId: bundleID,
                                _dynamicBoxIndex: dynamicBoxIndex,
                                _custom_product_title: customProductTitle,
                                _custom_image: customImage,
                                _custom_title: customTitle,
                                _custom_serving: customServing,
                                _custom_price: customPrice,
                                _custom_compare_price: customComparePrice,
                                _custom_sub_price: customSubPrice,
                                _custom_sub_compare_price: customSubComparePrice,            
                                _custom_quantity: customQuantity,
                                _custom_quantity_group: customQuantityGroup,
                                _customSellingPlanName: customSellingPlan
                            }; 

                            const idArray = typeof data.ids === 'string' ? data.ids.split(',') : data.ids;
                            const planArray = typeof data.plans === 'string' ? data.plans.split(',') : (data.plans || []);
                            const qtyArray = typeof data.qtys === 'string' ? data.qtys.split(',') : (data.qtys || []);
                            
                            itemsToAdd = idArray.map((id, index) => {
                                const itemBaseQty = parseInt(qtyArray[index]) || 1;
                                const itemProperties = { 
                                    ...mainProperties,
                                    _base_qty: itemBaseQty.toString(),
                                    _role: index === 0 ? 'main' : 'hidden',
                                    _uniqBundleId: uniqID
                                };
                                const item = {
                                    id: id.toString().trim(),
                                    quantity: itemBaseQty,
                                    properties: itemProperties
                                };
                                if (planArray[index] && planArray[index] !== "") {
                                    item.selling_plan = parseInt(planArray[index]);
                                }
                                return item;
                            });
                        }
                    }
                } else {
                    itemsToAdd.push({
                        id: variantId,
                        quantity: 1,
                        selling_plan: sellingPlanId || null
                    });
                }

                const productShouldBe = {
                    items: itemsToAdd,
                    sections: cartDrawerSticky?.getSectionsToRender()?.map(section => section.section) || [],
                    sections_url: window.location.pathname
                };            
                
                submitBtn.classList.add('loading');
                submitBtn.disabled = true;
                cartDrawerSticky?.enableLoading();
                
                fetch('/cart/add.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'X-Requested-With': 'XMLHttpRequest'
                    },
                    body: JSON.stringify(productShouldBe),
                    credentials: 'same-origin'
                })
                .then(async (response) => {
                    const data = await response.json();
                    if (!response.ok) {
                        console.error("Shopify Cart Error Response:", data);
                        throw new Error(data.description || data.message || "Failed to add items to cart (409 Conflict)");
                    }
                    return data;
                })
                .then(parsedState => {
                    cartDrawerSticky?.renderContent(parsedState.sections);
                })
                .catch(console.error)
                .finally(() => {
                    cartDrawerSticky?.disableLoading();
                    cartDrawerSticky?.open();
                    document.querySelector('.cart_drawers__cross')?.setAttribute('role', 'button');
                    document.querySelector('.cart_drawers__cross')?.setAttribute('tabindex', '0');                
                    submitBtn.classList.remove('loading');
                    submitBtn.disabled = false;
                });
            });
        });
    }    

    if( document?.querySelectorAll('[js-widget-overview]').length > 0 ){
        document?.querySelectorAll('[js-widget-overview]').forEach((el)=>{
            el.addEventListener('click', (target) => {
                target.preventDefault();
                const offsetRvw = document?.querySelector('.custom__product__widget').offsetTop - header.clientHeight - stickyFormContainer.clientHeight;
                window.scrollTo({
                top: offsetRvw,
                behavior: 'smooth'
                });
            })
        })
    }  

    if (document.querySelectorAll('.table__standards__chart__brief_swp.swiper').length > 0) {
        document.querySelectorAll('.table__standards__chart__brief_swp.swiper').forEach((swiperinitilize, index) => {
            new Swiper(swiperinitilize, {
                slidesPerView: 'auto',
                breakpoints: {
                    0: { spaceBetween: 8 },
                    750: { spaceBetween: 0 }
                },
                pagination: { el: `.swiper-pagination.pagination_table_chart`, clickable: true },
                navigation: { nextEl: `.swiper-button-next.next_table_chart`, prevEl: `.swiper-button-prev.prev_table_chart` }
            });
        });
    }    

    const graph__card = document.getElementById("animated__graphs__card");
    if(graph__card){
        const observerOptions = {
            root: null,
            threshold: 0.3
        };
        const observer = new IntersectionObserver((entries, observerInstance) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    graph__card.classList.add("in-view");
                    observerInstance.unobserve(entry.target);
                }
            });
        }, observerOptions);
        observer.observe(graph__card);    
    }

})